export const rules = {
	// Card titles
	"rules.card.rules.title": "Rules",
	"rules.card.goals.title": "Goals",
	"rules.card.cleanSheets.title": "Clean sheets",
	"rules.card.cards.title": "Cards",
	"rules.card.misc.title": "Miscellaneous",
	"rules.card.captains.title": "Captains & Vice Captains",
	"rules.card.eligibility.title": "Eligibility & Prizes",
	"rules.card.weeklyPrizes.title": "Weekly Prize Structure",
	"rules.card.finalRules.title": "Prize Distribution & Tie-Breaking",

	// Main rules content
	"rules.intro":
		'All capitalized terms used in these rules (the <strong>"Rules"</strong>) shall carry the definition ascribed thereto in the terms and conditions (the <strong>"Terms and Conditions"</strong>).',

	"rules.rule1":
		"Participants can select their best team every week/round (as the case may be), relevant to the competition that the Betway Scores BW Fantasy Football game relates to e.g. English Premier League, etc. The Betway Scores BW Fantasy Football competition will commence on 11 March 2025 and will conclude at the end of the 2025/2026 football season.",

	"rules.rule2": "Each week/round correlates with that league's rounds.",

	"rules.rule3":
		"Participants can select a maximum of two (2) players per participating league team to include in their Betway Scores BW Fantasy Football team every week/round.",

	"rules.rule4":
		"Participants need to actively select their team every week/round, with the option to make changes or choosing to keep the same team in place for the following week/round.",

	"rules.rule5":
		"Points are allocated as follows for each of the following actions performed by the players that the Participant selects in their Betway Scores BW Fantasy Football team every week/round:",

	// Goals points
	"rules.goals.forwardGoals": "Forward's goals",
	"rules.goals.forwardGoalsValue": "4",
	"rules.goals.midfielderGoals": "Midfielder's goals",
	"rules.goals.midfielderGoalsValue": "5",
	"rules.goals.defenderGoals": "Defender's goals",
	"rules.goals.defenderGoalsValue": "10",
	"rules.goals.goalkeeperGoals": "Goalkeeper's goals",
	"rules.goals.goalkeeperGoalsValue": "20",
	"rules.goals.penaltyGoals": "Penalty goals",
	"rules.goals.penaltyGoalsValue": "3",
	"rules.goals.ownGoals": "Own goals",
	"rules.goals.ownGoalsValue": "-5",
	"rules.goals.concededGoals": "Conceded goals",
	"rules.goals.concededGoalsValue": "-1",

	// Clean sheets points
	"rules.cleanSheets.goalkeeperCleanSheet": "Goalkeeper's clean sheet",
	"rules.cleanSheets.goalkeeperCleanSheetValue": "5",
	"rules.cleanSheets.defenderCleanSheet": "Defender's clean sheet",
	"rules.cleanSheets.defenderCleanSheetValue": "5",
	"rules.cleanSheets.midfielderCleanSheet": "Midfielder's clean sheet",
	"rules.cleanSheets.midfielderCleanSheetValue": "1",

	// Cards points
	"rules.cards.yellowCard": "Yellow cards",
	"rules.cards.yellowCardValue": "-2",
	"rules.cards.redCard": "Red cards",
	"rules.cards.redCardValue": "-5",

	// Misc points
	"rules.misc.assists": "Assists",
	"rules.misc.assistsValue": "4",
	"rules.misc.shotsOnTarget": "Shots on target",
	"rules.misc.shotsOnTargetValue": "1",
	"rules.misc.tackles": "Tackles",
	"rules.misc.tacklesValue": "2",
	"rules.misc.saves": "Saves",
	"rules.misc.savesValue": "1",
	"rules.misc.minutesOver60": "Minutes played equal or over 60",
	"rules.misc.minutesOver60Value": "2",
	"rules.misc.minutesUnder60": "Minutes played under 60",
	"rules.misc.minutesUnder60Value": "1",
	"rules.misc.penaltyWon": "Penalty won",
	"rules.misc.penaltyWonValue": "3",
	"rules.misc.penaltiesConceded": "Penalty conceded",
	"rules.misc.penaltiesConcededValue": "-3",
	"rules.misc.penaltyMissed": "Penalty missed",
	"rules.misc.penaltyMissedValue": "-3",
	"rules.misc.offsides": "Offsides",
	"rules.misc.offsidesValue": "-1",
	"rules.misc.foulsCommitted": "Fouls committed",
	"rules.misc.foulsCommittedValue": "-1",

	// Captain rules
	"rules.rule6":
		'Participants can allocate a <strong>"Captain"</strong> to their team who will receive 3x points. The Captain can be changed every week/round. Whether the Captain is changed for the following week/round or is kept in place for the following week/round, needs to be actively selected every week/round by the Participant.',

	"rules.rule7":
		'Participants can allocate a <strong>"Vice Captain"</strong> to their team who will receive 2x points. The Vice Captain can be changed every week/round. Whether the Vice Captain is changed for the following week/round or is kept in place for the following week/round, needs to be actively selected every week by the Participant.',

	// Eligibility and prizes
	"rules.rule8":
		"All signed in Betway Scores and/or BW Scores users are eligible to play BW Fantasy Football, however only participants with a verified Betway account, at the point when prizes are to be awarded, are eligible to win prizes. Changes to the results of the rounds as per point 2. above (affecting the points under 5. above) which occur after awarding the prizes (e.g. annulment of game results) will not be considered in retrospect.",

	"rules.rule9":
		"The qualifying and eligible Participant who finishes the season in first place and has a Betway Betting Account will be the Grand Prize winner for the season will win a trip for two (2) to watch Arsenal play in London, including flights (if required), accommodation (if required) and £500 spending money.",

	"rules.rule10":
		"If the Grand Prize winner for the season is not able to travel due to not having a valid passport and/or Visa and/or any other limitations, they will receive a prize of €5,000 Cash balance, or the approximate equivalent in local currency at competition commencement date (being £4,500, R100,000 or GH₵ 60,000), into their Betway Account at the completion of the competition.",

	"rules.rule11":
		"The Grand Prize winner of the season can opt not to take up the experience and rather accept a prize of €5,000 Cash balance, or the approximate equivalent in local currency at competition commencement date (being £4,500, R100,000 or GH₵ 60,000), into their Betway Account.",

	"rules.rule12":
		"Weekly Prizes will be allocated to the Top 10 performers every week/round who have a valid Betway Betting Account. If a Top 10 performer does not have a Betway Betting Account they will not be awarded a Weekly Prize.",

	"rules.rule13": "The weekly places 1 to 10 will win the following amounts of Cash balance, depending on the region, into their Betway Account:",

	// Weekly prize table headers
	"rules.weeklyPrizes.position": "Position Per Round",
	"rules.weeklyPrizes.eur": "Cash Balance Winnings (EUR)",
	"rules.weeklyPrizes.gbp": "Cash Balance Winnings (GBP)",
	"rules.weeklyPrizes.zar": "Cash Balance Winnings (ZAR)",
	"rules.weeklyPrizes.ghs": "Cash Balance Winnings (GHS)",

	// Weekly prize values
	"rules.weeklyPrizes.1st.eur": "€150",
	"rules.weeklyPrizes.1st.gbp": "£150",
	"rules.weeklyPrizes.1st.zar": "R3000",
	"rules.weeklyPrizes.1st.ghs": "GH₵ 2000",

	"rules.weeklyPrizes.2nd.eur": "€100",
	"rules.weeklyPrizes.2nd.gbp": "£100",
	"rules.weeklyPrizes.2nd.zar": "R2000",
	"rules.weeklyPrizes.2nd.ghs": "GH₵ 1250",

	"rules.weeklyPrizes.3rd.eur": "€75",
	"rules.weeklyPrizes.3rd.gbp": "£75",
	"rules.weeklyPrizes.3rd.zar": "R1500",
	"rules.weeklyPrizes.3rd.ghs": "GH₵ 1000",

	"rules.weeklyPrizes.4th.eur": "€50",
	"rules.weeklyPrizes.4th.gbp": "£50",
	"rules.weeklyPrizes.4th.zar": "R1000",
	"rules.weeklyPrizes.4th.ghs": "GH₵ 600",

	"rules.weeklyPrizes.5th.eur": "€40",
	"rules.weeklyPrizes.5th.gbp": "£40",
	"rules.weeklyPrizes.5th.zar": "R800",
	"rules.weeklyPrizes.5th.ghs": "GH₵ 500",

	"rules.weeklyPrizes.6th.eur": "€30",
	"rules.weeklyPrizes.6th.gbp": "£30",
	"rules.weeklyPrizes.6th.zar": "R600",
	"rules.weeklyPrizes.6th.ghs": "GH₵ 400",

	"rules.weeklyPrizes.7th.eur": "€20",
	"rules.weeklyPrizes.7th.gbp": "£20",
	"rules.weeklyPrizes.7th.zar": "R400",
	"rules.weeklyPrizes.7th.ghs": "GH₵ 250",

	"rules.weeklyPrizes.8th.eur": "€15",
	"rules.weeklyPrizes.8th.gbp": "£15",
	"rules.weeklyPrizes.8th.zar": "R300",
	"rules.weeklyPrizes.8th.ghs": "GH₵ 200",

	"rules.weeklyPrizes.9th.eur": "€10",
	"rules.weeklyPrizes.9th.gbp": "£10",
	"rules.weeklyPrizes.9th.zar": "R200",
	"rules.weeklyPrizes.9th.ghs": "GH₵ 100",

	"rules.weeklyPrizes.10th.eur": "€10",
	"rules.weeklyPrizes.10th.gbp": "£10",
	"rules.weeklyPrizes.10th.zar": "R200",
	"rules.weeklyPrizes.10th.ghs": "GH₵ 100",

	// Final rules
	"rules.rule14":
		"The Weekly Prizes will be awarded within 7 (seven) days of that week's results being finalised and the Grand Prize will be awarded within 7 (seven) days of the conclusion of the Betway Scores BW Fantasy Football competition.",

	"rules.rule15":
		"In the event of a tie for the Weekly Prizes the Cash balance for that position (and the relevant positions below it that are impacted by the tie) will be split equally between tied participants.",

	"rules.rule16":
		"In the event of a tie for the Grand Prize, a randomizer mechanism will be used to select only one of the tied participants as the winner of the Grand Prize.",

	"rules.temporary_notice":
		"Please note that prize winners over the period of 19th December 2025 - 2nd January 2026 will receive their prizes within the 7 (seven) days starting from 6th January 2026",
};
